import { FaEnvelopeOpenText } from 'react-icons/fa';
import { Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn, H5 } from '../../../AbstractElements';
import { ContactUs, Email, Message, SEND_IT, YourName } from '../../../Constant';

const ContactUsWidgets = () => {
  return (
      <Col sm='12' lg='6' xl='8' md='12' className='xl-50 box-col-6'>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{ContactUs}</H5>
          </CardHeader>
          <CardBody className='contact-form'>
            <Form className='theme-form'>
              <div className='form-icon'>
                <FaEnvelopeOpenText />
              </div>
              <FormGroup>
                <Label for='exampleInputName'>{YourName}</Label>
                <Input className='form-control' id='exampleInputName' type='text' placeholder='John Dio' />
              </FormGroup>
              <FormGroup>
                <Label className='col-form-label' htmlFor='exampleInputEmail1'>
                  {Email}
                </Label>
                <Input className='form-control' id='exampleInputEmail1' type='email' placeholder='Demo@gmail.com' />
              </FormGroup>
              <FormGroup>
                <Label className='col-form-label' htmlFor='exampleInputEmail1'>
                  {Message}
                </Label>
                <Input className='form-control' type='textarea' rows='3' cols='50' placeholder='Your Message'></Input>
              </FormGroup>
              <div className='text-sm-end'>
                <Btn color='primary' type='reset'>
                  {SEND_IT}
                </Btn>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
  );
};
export default ContactUsWidgets;
